import { render, staticRenderFns } from "./info_segepidexprofe.vue?vue&type=template&id=71f4ae2b"
import script from "./info_segepidexprofe.vue?vue&type=script&lang=js"
export * from "./info_segepidexprofe.vue?vue&type=script&lang=js"
import style0 from "./info_segepidexprofe.vue?vue&type=style&index=0&id=71f4ae2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports